import Controller from '@ember/controller';

import { action, set } from '@ember/object';
import { beebeeAjaxPost } from 'beebee-base/lib/utility';
import { task } from 'ember-concurrency';

import { inject as iService } from '@ember/service';

import { inject as iController } from '@ember/controller';

import getConfig from 'beebee-base/lib/get-config';
export default class UseVoucherController extends Controller {
  @iService notify;
  queryParams = ['code'];
  @iService router;
  @iService intl;
  @iService session;
  @iController('application') applicationController;

  @(task(function* () {
    if (!this.code) {
      return;
    }

    set(this, 'voucherLists', null);
    set(this, 'voucherAPI', null);

    try {
      const voucherAPI = yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/booking_get_voucher`, null, {
        code: this.code,
      });

      if (!voucherAPI?.products) {
        this.notify.warning(this.intl.t('voucher.not_valid'));
      } else {
        set(this, 'voucherAPI', voucherAPI);
      }
    } catch (e) {
      this.notify.warning(this.intl.t('voucher.not_valid'));
    }
  }).restartable())
  getVoucherTask;

  @action
  setVoucher(p, e) {
    set(this, 'applicationController.voucherToUse', this.voucherAPI);

    this.router.transitionTo('index', {
      queryParams: {
        product: p.id,
      },
    });
  }

  @action
  clickLogo() {}
}
